import React, {useEffect} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";

import {
  disableNotSelectedFeatureGroups,
  getCurrentGroups,
  getFeatureGroupFromWizardGroup, getNextWizardStepQuantity,
  useHideItemsDisabledfeatureGroups
} from "./lookWizardFunctions";
import {setLookActiveFeature} from "../../../../../actions/lookFunctions";
import {setGroheActiveFeatureQuantity} from "../../../../../actions/groheFunctions";
import {useUpdateMatchAllButton} from "../../../../../misc/helperHooks";
import {useUpdateLookWizardViewType} from "./lookWizardHooks";
import {useLookWizardStepChanges} from "./useLookWizardStepChanges";
import {
  setWizardActiveStep,
  setWizardSelectedValues,
  setWizardShowFeatureSection
} from "../../../../../actions/wizardFunctions";
import LookWizardContext from "./lookWizardContext";

const LookWizardContextAndHooks = (props) => {

  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues, updateLookCartItem, setWizardShowFeatureSection,
    setLookActiveFeature, setGroheActiveFeatureQuantity, wizardShowFeatureSection, wizardSqftCartItems,
    visualizersLoadedLength, setWizardSelectedValues, setWizardActiveStep} = props;
  // const {customImageUrl, uploadedImageUrl} = wizardActiveItem;

  const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);
  const wizardGroup = currentGroups[0];

  let featureGroup = null;
  let selectedWizardCustomGroup = null;
  if (currentGroups.length === 1 && currentGroups[0].nodeType === "group") {
    featureGroup = getFeatureGroupFromWizardGroup(wizardGroup);
  } else if (currentGroups.length && currentGroups[0].nodeType === "custom"
    && wizardSelectedValues[wizardActiveStep]?.wizardGroup) {
    selectedWizardCustomGroup = wizardSelectedValues[wizardActiveStep].wizardGroup;
  }

  const selectedFeature = wizardSelectedValues[wizardActiveStep]?.selectedFeature;
  const isSingleFeature = wizardSelectedValues[wizardActiveStep]?.singleFeature;
  const featureGroupFeature = featureGroup && featureGroup.activeFeature && !currentGroups[0].title
    ? featureGroup.activeFeature
    : null;

  const selectedWizardFeature = selectedFeature;

  const isCompletedStep = wizardActiveStep > -1 && !currentGroups.length;

  const lookWizardContextValues = {
    currentGroups,
    featureGroup,
    wizardGroup,
    isCompletedStep,
    selectedWizardFeature,
    featureGroupFeature,
    isSingleFeature,
    selectedWizardCustomGroup,
  }

  useEffect(() => {
    if (isCompletedStep && wizardActiveItem?.hideItems) {
      disableNotSelectedFeatureGroups(wizardActiveItem, wizardSelectedValues);
    }
    // it awkwardly jumps !! don't enable it
    // if (featureGroup && imageCanvas && imageCanvas.current && imageCanvas.current.pinchZoom) {
    //   const commonCoords = getCommonCoords(featureGroup, null, imageCanvas.current.canvas);
    //   const center = getLayerCenter(commonCoords, imageCanvas.current.canvas, isMobile);
    //   if (center) {
    //     imageCanvas.current.pinchZoom.zoomToCenter(center, 0, false, true);
    //     setCanvasScale(imageCanvas.current.pinchZoom.options.tapZoomFactor)
    //   }
    // }

    setGroheActiveFeatureQuantity(getNextWizardStepQuantity(currentGroups, wizardSelectedValues, wizardActiveStep));

    const nextActiveFeature = wizardSelectedValues[wizardActiveStep] && wizardSelectedValues[wizardActiveStep].selectedFeature
      ? wizardSelectedValues[wizardActiveStep].selectedFeature
      : null;
    setLookActiveFeature(nextActiveFeature);

    updateLookCartItem();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wizardActiveStep]);

  useLookWizardStepChanges({
    wizardShowFeatureSection,
    setWizardShowFeatureSection,
    wizardSelectedValues,
    setWizardSelectedValues,
    wizardActiveStep,
    setWizardActiveStep,
    wizardActiveItem,
    setGroheActiveFeatureQuantity,
    wizardSqftCartItems,
  });

  useUpdateMatchAllButton(wizardGroup, featureGroup);

  useUpdateLookWizardViewType(wizardGroup);

  useHideItemsDisabledfeatureGroups(wizardActiveItem, visualizersLoadedLength, wizardSelectedValues, updateLookCartItem);

  return (
    <LookWizardContext.Provider value={lookWizardContextValues}>
      {props.children}
    </LookWizardContext.Provider>
  )
};

LookWizardContextAndHooks.propTypes = {
  updateLookCartItem: PropTypes.func,
}

const mapStateToProps = (store) => {
  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues, wizardShowFeatureSection, wizardSqftCartItems}
    = store.wizardState;
  const {isMobile, visualizersLoaded} = store.serverState;

  return {
    wizardActiveItem,
    wizardActiveStep,
    wizardSelectedValues,
    wizardShowFeatureSection,
    wizardSqftCartItems,
    isMobile,
    visualizersLoadedLength: visualizersLoaded.length,
  };
};

const mapDispatchToProps = {
  setLookActiveFeature,
  setWizardShowFeatureSection,
  setWizardSelectedValues,
  setGroheActiveFeatureQuantity,
  setWizardActiveStep,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LookWizardContextAndHooks)
)
